var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.78378 8.71826C9.58628 7.89932 10.0811 6.77771 10.0811 5.54054C10.0811 3.03287 8.04821 1 5.54054 1C3.03287 1 1 3.03287 1 5.54054C1 8.04821 3.03287 10.0811 5.54054 10.0811C6.81104 10.0811 7.95966 9.55926 8.78378 8.71826ZM8.78378 8.71826L13 13",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchW);
export default __webpack_public_path__ + "static/media/SearchW.6163f0ad9732cc1a3a72e1758a87a9c9.svg";
export { ForwardRef as ReactComponent };